module.exports = __webpack_public_path__ + "static/media/IMG_5903-min.c6bdef0c.jpg";